import UCookie from 'universal-cookie';
import { APP_DOMAIN, CookieKeys } from './Constant';

const prefix = '@bukki/';

export const cookie = new UCookie();

export const Cookie = {
  setItem: (key, data) => {
    return cookie.set(`${prefix}${key}`, data, { path: '/', domain: APP_DOMAIN });
  },
  getItem: key => {
    return cookie.get(`${prefix}${key}`);
  },
  removeItem: key => {
    return cookie.remove(`${prefix}${key}`, { path: '/', domain: APP_DOMAIN });
  },
  clearSession(path) {
    this.removeItem(CookieKeys.accessToken, { path: path || '/', domain: APP_DOMAIN });
    this.removeItem(CookieKeys.refreshToken, { path: path || '/', domain: APP_DOMAIN });
    this.removeItem(CookieKeys.user, { path: path || '/', domain: APP_DOMAIN });
  },
};
